import React from 'react';
import { FaMoon, FaSun } from 'react-icons/fa';

const ThemeToggle = ({ darkMode, setDarkMode }) => {
  return (
    <button
      onClick={() => setDarkMode(!darkMode)}
      className='fixed pointer-events-auto bottom-8 right-8 z-[1000] w-12 h-12 bg-gradient-to-br from-blue-500 to-indigo-800 rounded-full flex items-center justify-center text-white text-lg shadow-lg hover:scale-110 hover:rotate-30 hover:shadow-xl transition-all duration-300'
    >
      {darkMode ? <FaSun /> : <FaMoon />}
    </button>
  );
};

export default ThemeToggle;
